import { useNavigate } from '@tanstack/react-router';
import { useState } from 'react';

import {
  MeadowHeader,
  MeadowLegal,
  MeadowScene,
} from '@/components/blocks/auth/MeadowAuthForm';
import { Button } from '@/components/ui/Button';
import { YStack } from '@/components/ui/layout/layout';

import { redeemChannelSignIn, safeChannelSignInNext } from './channel-sign-in';

export function ChannelSignInConfirmation({
  code,
  currentEmail,
  email,
  next,
}: {
  code: string;
  currentEmail: string | null;
  email: string;
  next: string;
}) {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const safeNext = safeChannelSignInNext(next);
  const continueAsOwner = async () => {
    setIsSubmitting(true);
    await redeemChannelSignIn(code);
    await navigate({ href: safeNext, replace: true });
  };
  const staySignedIn = () => {
    void navigate({ href: safeNext, replace: true });
  };

  const description = currentEmail
    ? `You're signed in as ${currentEmail}. This link from your Littlebird chat signs you in as ${email}.`
    : `This link from your Littlebird chat signs you in as ${email}.`;

  return (
    <MeadowScene>
      <YStack className="flex-1 justify-center">
        <MeadowHeader title="Sign in to Littlebird" description={description} />
        <YStack className="gap-3">
          <Button
            size="lg"
            className="w-full"
            onClick={() => void continueAsOwner()}
            disabled={isSubmitting}
            isLoading={isSubmitting}
          >
            {currentEmail ? `Switch to ${email}` : `Continue as ${email}`}
          </Button>
          {currentEmail && (
            <Button
              variant="outline"
              size="lg"
              className="w-full"
              onClick={staySignedIn}
              disabled={isSubmitting}
            >
              Stay as {currentEmail}
            </Button>
          )}
        </YStack>
      </YStack>
      <MeadowLegal />
    </MeadowScene>
  );
}
